/**
 * The question a Watch notice asks and its two answers, in one place (ENTRAID-347). The email renderer
 * (backend/lib/watch-render.mjs) and the portal event page (frontend WatchEventPage) both read it, so the
 * wording cannot drift between the email buttons and the page radios.
 * ENTRAID-346: the person asked about their own risky sign-in answers "Was this you?"; everyone else keeps "Was this expected?".
 */
import { RISK_EVENT_ID } from './watch-catalog.mjs';

export const WATCH_QUESTION_DEFAULT = Object.freeze({ question: 'Was this expected?', yes: 'Yes, this was expected', no: 'No, this was not expected' });
export const WATCH_QUESTION_SELF_RISK = Object.freeze({ question: 'Was this you?', yes: 'Yes, this was me', no: 'No, this was not me' });

/** @param {string|undefined} catalogId @param {string[]} [audiences] the recipient's audiences */
export function watchQuestion(catalogId, audiences = []) {
  const forSelf = (audiences ?? []).includes('self');
  return catalogId === RISK_EVENT_ID && forSelf ? WATCH_QUESTION_SELF_RISK : WATCH_QUESTION_DEFAULT;
}
